// src/components/reusable/ChipFilterStyles.js

const chipFilterStyles = {
  chip: {
    fontSize: '0.875rem',
    height: 32,
  },

  activeChip: {
    fontSize: '0.875rem',
    height: 32,
    backgroundColor: '#e0d8f6',
    color: '#5236AB',
  },

  clearAll: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: '#fff',
    borderTop: '1px solid #ddd',
    color: '#5236AB',
    fontWeight: 'bold',
    zIndex: 1300,
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
};

export default chipFilterStyles;
